import { IconClose16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './Tag.css';

export interface ITagProps extends React.PropsWithChildren {
  onRemove(): void;
}

export const Tag: React.FC<ITagProps> = ({ children, onRemove }) => {
  return (
    <div className={styles['container']}>
      {children}
      <button className={styles['button']} onClick={onRemove}>
        <IconClose16 color="current_color" />
      </button>
    </div>
  );
};
